var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u95EE\u7B54") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5E2E\\u52A9",
    transform: "translate(-72.000000, -634.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u95EE\\u7B54",
    transform: "translate(72.000000, 634.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,3.33332031 C29.2045703,3.33332031 36.6666797,10.7954297 36.6666797,20 C36.6666797,29.2045703 29.2045703,36.666698 20,36.666698 C16.9850856,36.6711554 14.0259242,35.8541095 11.4404297,34.3033203 C11.1799371,34.1490414 10.918802,33.99585 10.6570312,33.84375 L6.57871094,34.95625 C5.64539063,35.2104297 4.78953125,34.3541797 5.04414063,33.42125 L6.15496094,29.3475 C5.72496094,28.6175 5.44328125,28.1279297 5.30328125,27.8666406 C4.00625004,25.4476602 3.32939238,22.7447661 3.33330331,20 C3.33330331,10.7954297 10.7954297,3.33332031 20,3.33332031 L20,3.33332031 Z M20,26.25 C19.3096441,26.25 18.75,26.8096441 18.75,27.5 C18.75,28.1903559 19.3096441,28.75 20,28.75 C20.6903559,28.75 21.25,28.1903559 21.25,27.5 C21.25,26.8096441 20.6903559,26.25 20,26.25 Z M19.9016797,11.6666797 C18.0104297,11.6666797 16.27875,12.6104297 15.2683203,14.14375 C15.002747,14.546437 14.792801,14.9831611 14.6441797,15.4420703 C14.4317766,16.0990519 14.7921786,16.8038274 15.4491602,17.0162305 C16.1061417,17.2286336 16.8109172,16.8682315 17.0233203,16.21125 C17.1025384,15.9665852 17.2145332,15.7337786 17.35625,15.5191797 C17.90625,14.6841797 18.8558594,14.1666797 19.9016797,14.1666797 C21.5733203,14.1666797 22.9166797,15.4791797 22.9166797,17.0833203 C22.9166797,18.6874609 21.5729297,20 19.90125,20 C19.2108941,20 18.65125,20.5596441 18.65125,21.25 L18.65125,23.75 C18.65125,24.4403559 19.2108941,25 19.90125,25 C20.5916059,25 21.15125,24.4403559 21.15125,23.75 L21.15125,22.36 C23.5916797,21.8045703 25.4166797,19.6575 25.4166797,17.0833203 C25.4166797,14.085 22.9408203,11.6666797 19.90125,11.6666797 L19.9016797,11.6666797 Z",
    id: "\\u5F62\\u72B6",
    fill: "#5795F1"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon_question.aa4059ceba929076e7b873b28c72fac9.svg";
export { ForwardRef as ReactComponent };